module.exports = __webpack_public_path__ + "img/faq.8647b574.svg";